import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  NAVIGATE_TO_CHAT_EVENT,
  dispatchOpenChat,
  setPendingOpenChatId,
} from '../utils/chatNavigation';

/** Routes notification / deep-link chat opens without browser storage. */
const ChatNavigationBridge = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const onNavigateToChat = (event) => {
      const chatId = event.detail?.chatId;
      if (window.location.pathname.startsWith('/chats')) {
        if (chatId) {
          dispatchOpenChat(chatId);
        }
        return;
      }
      if (chatId) {
        setPendingOpenChatId(chatId);
      }
      navigate('/chats');
    };

    window.addEventListener(NAVIGATE_TO_CHAT_EVENT, onNavigateToChat);
    return () => window.removeEventListener(NAVIGATE_TO_CHAT_EVENT, onNavigateToChat);
  }, [navigate]);

  return null;
};

export default ChatNavigationBridge;
